import { gql } from '@apollo/client';

import { academyProfessorFragment } from '../fragments';
import { AcademyProfessor } from '../../types';

export interface SetAcademyProfessorRoleMutationVariables {
  professorId: string;
  input: {
    role: string;
  };
}

export interface SetAcademyProfessorRoleMutationResult {
  academyProfessor: AcademyProfessor;
}

export const setAcademyProfessorRoleMutation = gql`
  mutation SetAcademyProfessorRoleMutation($professorId: String!, $input: SetAcademyProfessorRoleMutationInput!) {
    academyProfessor(professorId: $professorId, input: $input)
      @rest(type: "AcademyProfessor", path: "academy/professors/{args.professorId}/role", method: "PUT") {
      ...AcademyProfessor
    }
  }
  ${academyProfessorFragment}
`;
